import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DeviceService } from 'app/services/models/device.service';
import { ReferenceDeviceMovementService } from 'app/services/models/reference-device-movement.service';
import { Turkish } from 'flatpickr/dist/l10n/tr';
import { FlatpickrOptions } from 'ng2-flatpickr';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-dialog-reference-device-movement',
  templateUrl: './dialog-reference-device-movement.component.html',
  styleUrls: ['./dialog-reference-device-movement.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DialogReferenceDeviceMovementComponent implements OnInit {
  @Input() data: { message: string, id: number, deviceId: number, isMeasurementValue: boolean };

  referenceDeviceForm: FormGroup;

  date = new Date();
  date2: Date = new Date();


  public dateTimeStartOptions: FlatpickrOptions = {
    altInput: true,
    enableTime: true,
    dateFormat: 'd.m.Y',
    altFormat: 'd.m.Y',
    locale: Turkish,
    defaultDate: this.date
  };

  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private referenceDeviceService: ReferenceDeviceMovementService,
    private toastrService: ToastrService,
    private deviceServce: DeviceService) { }

  async ngOnInit() {
    console.log(this.data);
    this.referenceDeviceForm = this.fb.group({
      certificateNo: [null, [Validators.required, Validators.maxLength(20)]], // Tek firma seçimi
      calibrationDate: [null, Validators.required],
      futureCalibrationDate: [null, Validators.required],
      traceability: [null, Validators.required],
      acceptanceCriterion: [null, [Validators.required, Validators.maxLength(30)]],
      calibrationCertificateUncertainty: [null, [Validators.required, Validators.maxLength(30)]],// Birden fazla ürün formu
      nominalValue: [null, this.data.isMeasurementValue ? [Validators.required] : []],
      measuredValue: [null, this.data.isMeasurementValue ? [Validators.required] : []],
      tolerance: [null, this.data.isMeasurementValue ? [Validators.required] : []]
    });
    await this.getByIdDevice(this.data.deviceId);

    if (this.data.id) {
      await this.getByIdreferenceDevice(this.data.id);
    }

    this.referenceDeviceForm.get('calibrationDate').valueChanges.subscribe((selectedDate) => {
      if (this.data.id == null) {
        if (selectedDate) {
          const futureDate = new Date(selectedDate);
          this.date2 = new Date(futureDate.setFullYear(futureDate.getFullYear() + 1));
          this.referenceDeviceForm.get('futureCalibrationDate').setValue(this.date2);
        }
      }
    });
  }


  async getByIdreferenceDevice(id) {
    const data = await this.referenceDeviceService.getByIdReferenceDeviceMovement(id);
    console.log(data);
    this.date = new Date(data.calibrationDate);
    this.date2 = new Date(data.futureCalibrationDate);
    if (data) {
      this.referenceDeviceForm.patchValue({
        certificateNo: data.certificateNo,
        calibrationDate: data.calibrationDate,
        futureCalibrationDate: data.futureCalibrationDate,
        traceability: data.traceability,
        acceptanceCriterion: data.acceptanceCriterion,
        calibrationCertificateUncertainty: data.calibrationCertificateUncertainty,
        nominalValue: data.nominalValue,
        measuredValue: data.measuredValue,
        tolerance: data.tolerance
      });
    }
  }


  closeModal() {
    this.activeModal.close(false);
  }

  async onSumbit() {
    if (this.referenceDeviceForm.valid) {
      // Formdan gelen temel değerleri alıyoruz
      const formValues = this.referenceDeviceForm.value;

      // Ortak veri objesini hazırlıyoruz
      const baseData = {
        id: this.data.id ? Number(this.data.id) : null,
        deviceId: Number(this.data.deviceId),
        certificateNo: formValues.certificateNo,
        calibrationDate: formValues.calibrationDate?.[0] ?? null,
        futureCalibrationDate: formValues.futureCalibrationDate?.[0] ?? null,
        traceability: formValues.traceability,
        acceptanceCriterion: formValues.acceptanceCriterion,
        calibrationCertificateUncertainty: formValues.calibrationCertificateUncertainty,
        // Eğer isMeasurementValue true ise formdan al, değilse null gönder
        nominalValue: this.data.isMeasurementValue ? formValues.nominalValue : null,
        measuredValue: this.data.isMeasurementValue ? formValues.measuredValue : null,
        is_MeasuredValue: this.data.id ? null : this.data.isMeasurementValue,  // Backende bu bilgiyi de göndermek gerekebilir
        tolerance: this.data.isMeasurementValue ? formValues.tolerance : null
      };

      let response;
      if (this.data.id) {
        response = await this.referenceDeviceService.updateDeviceReferenceMovement(baseData);
      } else {
        response = await this.referenceDeviceService.createDeviceReferenceMovement(baseData);
      }

      if (response.status) {
        this.referenceDeviceService.sendEvent(true);
        this.toastrService.success(response.message);
        this.closeModal();
      } else {
        this.toastrService.error(response.message);
      }
    }
  }

  async getByIdDevice(id) {
    const data = await this.deviceServce.getByIdDevice(id);
    console.log(data);
    let targetDate = new Date();

    if (this.data.isMeasurementValue === true && data.period != null) {
      // data.period kadar AY ekle (Örn: 15, 24, 3 vb.)
      targetDate.setMonth(targetDate.getMonth() + data.period);
    } else {
      // Varsayılan olarak 1 YIL (12 ay) ekle
      targetDate.setFullYear(targetDate.getFullYear() + 1);
    }

    // Hesaplanan tarihi class değişkenine ata
    this.date2 = new Date(targetDate);
    this.referenceDeviceForm.patchValue({
      futureCalibrationDate: this.date2
    });
  }
}
